import React, { ReactElement, useCallback } from 'react';
import { Button, IconButton } from '@mui/material';
import LocalPrintshopRoundedIcon from '@mui/icons-material/LocalPrintshopRounded';

export const PrintRoadmap = (values) => {
  const printRoadMap = useCallback(() => {}, [values]);

  return (
    <>
      <IconButton
        onClick={() => {
          printRoadMap();
        }}
      >
        <LocalPrintshopRoundedIcon color={'primary'} />
      </IconButton>
    </>
  );
};
